function ECommerceServices() {
  return (
    <>
      <h1>These are thee Ecommerce services</h1>
    </>
  );
}

export default ECommerceServices;
